var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "estates-carousel" },
    [
      _c(
        "my-carousel",
        {
          ref: "carousel",
          attrs: {
            "per-page-custom": _vm.perPageCustom,
            "pagination-enabled": true,
            "scroll-per-page": true,
            "navigation-enabled": _vm.navigationEnabled,
            "navigation-next-label": "<span></span>",
            "navigation-prev-label": "<span></span>",
            "mouse-drag": false
          },
          on: { "page-change": _vm.onPageChange }
        },
        _vm._l(_vm.estates, function(estate) {
          return _c(
            "slide",
            { key: estate.id },
            [_c("estate-card", { attrs: { estate: estate, carousel: false } })],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }